import type { SendRequestType } from '@/lib/utils/shared/httpTools'
import httpTools from '@/lib/utils/shared/httpTools'

type HydraChangePasswordProps = {
  password: string
  hydraToken: string
}

type HydraChangePasswordResponse = {
  value: string
}

export const HydraChangePassword = async ({
  password,
  hydraToken,
}: HydraChangePasswordProps) => {
  const data = {
    value: password,
  }

  const request: SendRequestType = {
    method: 'POST',
    url: `/customers/me/password`,
    token: hydraToken,
    data,
  }

  return httpTools.sendRequest<HydraChangePasswordResponse>(request)
}
